import styled, { ITheme } from '../../../../../theme'

const FilteringFormBackground = styled.div`
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 1;

  @media (min-width: ${({ theme }: ITheme) => theme.breakpoints.tablet}) {
    width: 480px;
  }
`

export default FilteringFormBackground
